//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
  },
  name: 'regionSelect',
  data() {
    return {
      selectLength: {
        start: 0,
        length: 3
      },
      selectValue: {
        province: [''],
        city: ['441900'],
        district: ['']
      }
    }
  },
  methods: {
    clearSelect() {
      this.$refs.regionSelect.clearSelect();
    },
    reset() {
      this.$refs.regionSelect.reset();
    },
    getResult() {
      console.log(this.$refs.regionSelect.region)
      console.log(this.$refs.regionSelect.getResult());
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'baseURL'
    ])
  },
  created() {
  },
  mounted() {
  }
};
